import { getInputParams } from '../../../../common/services/airPrice'
import { graphAirPriceCall } from '../../../services/airPriceCall'
import { airPriceFireFlyQueryFareBrandsOnly } from '../../../../common/services/airPrice/airPriceFireflyQuery'
import { logTileCount } from '../../../../client/common/log-ga-event'
export const fetchUpsellTrayOptions = async ({
  itinerary,
  searchRequestParams,
} = {}) => {
  const res = await graphAirPriceCall({
    params: getInputParams({
      priceKey: itinerary?.priceKey,
      itemKey: itinerary?.itemKey,
      isPriceCall: true,
      params: searchRequestParams,
      fromPackages: false,
      workflowStep: 'UPSELLS',
    }),
    query: airPriceFireFlyQueryFareBrandsOnly,
  })
  const upsells = prepareUpsellTrayOptions({
    fareBrandsInfo: res?.graphResponse?.fareBrandsInfo,
    itinerary,
  })
  logTileCount(upsells?.length)
  return upsells
}

export const prepareUpsellTrayOptions = ({ itinerary, fareBrandsInfo }) => {
  return fareBrandsInfo?.slices?.[0]?.fareBrands
    ?.map(fb => {
      let pricing = fb?.pricing
      const isBaseFare = fb?.key === itinerary?.priceKey
      if (isBaseFare) {
        pricing = itinerary?.price?.find(price => price?.type === 'AVG_PRICE')
      }
      return {
        name: fb?.name,
        priceKey: fb?.key,
        pricing: {
          amount: isBaseFare ? pricing?.amount : pricing?.amountInFloat,
          text: isBaseFare ? '' : pricing?.text,
        },
        ancillaries: fb?.ancillaries
          ?.filter(anc =>
            ['CARRY_ON', 'SEATS', 'CHECKED_BAG'].includes(anc?.tag)
          )
          ?.map(anc => {
            return {
              tag: anc?.tag,
              name: anc?.name,
              description: anc?.name,
              offerType: anc?.offerType,
            }
          }),
      }
    })
    ?.slice(0, 3)
}
